import { css } from '@emotion/react'

export const button = css({
  backgroundColor: 'rgb(22, 27, 34)',
  color: '#fff',
  fontSize: '16px'
})
